import React from 'react';
import { View } from 'react-native';
import TableText from '../PanelsComponents/Text/TableText';
import UserTypeRow from './UserTypeRow';
import NewRow from './NewRow';

const Table = ({ allServices, userTypes, onConfigChanged }) => {
  const styles = {
    headLineRow: {
      flexDirection: 'row', height: 30,
    },
    row: {
      flexDirection: 'row', backgroundColor: '#f7fafc', height: 50,
    },
    squareIndex: {
      width: 30,
    },
    squareTypeID: {
      width: 100,
    },
    squareDescription: {
      width: 100,
    },
    squareServices: {
      flex: 1,
    },
    squareBorder: {
      padding: 5,
      border: 'solid 1px #cbd5e0',
    },

  };
  const removeRow = (index) => {
    console.log(userTypes, index);
    userTypes.splice(index, 1);
    onConfigChanged();
    console.log(userTypes);
  };

  return (
    <View>
      <View style={styles.headLineRow}>
        <View style={styles.squareIndex} />
        <View style={styles.squareTypeID}>
          <TableText text="Type ID" />
        </View>
        <View style={styles.squareDescription}>
          <TableText text="Description" />
        </View>
        <View style={styles.squareServices}>
          <TableText text="Services" />
        </View>
      </View>
      {userTypes.map((userType, index) => (
        <UserTypeRow
          key={userType.typeID}
          allServices={allServices}
          isDefaultRow={index === 0}
          userType={userType}
          index={index}
          removeRow={removeRow}
          onConfigChanged={onConfigChanged}
          showDeletePopup
        />
      ))}
      <NewRow addNewRow={() => {
        if (userTypes[userTypes.length - 1].typeID !== '') {
          userTypes.push({
            index: userTypes.length, typeID: '', description: '', services: [],
          });
        }
        onConfigChanged();
      }}
      />
    </View>
  );
};

export default Table;
